<template>
  <div class="page">
    <PhotoMakeHeader></PhotoMakeHeader>
    <div style="height: 10%"></div>
    <SearchInput @confirm="makePhoto" @close="closeSearchDialog" :show="inputShow"></SearchInput>
    <div class="search-contain">
      <input placeholder="输入规格名称或尺寸，例如“一寸”或“413”等" @focus="inputFocus" type="text" class="search-input">
      <div class="search-btn">搜索</div>
    </div>

    <div id="box">
      <div class="box-marquee">
        <div style="width: 8px;height: 8px;border-radius: 4px;background-color: #FF7BAC"></div>
        <span style="font-size: 12px;color: #FFFFFF;width: 44%;text-align: right">已选规格：</span>
        <OwnMarquee :text="marqueeTxt"></OwnMarquee>
      </div>
      <div style="height: 5%"></div>
      <img @load="imgSuccessListen" v-show="!spec_id&&imgLoadingState" @error="imgErrorListen" :src="photoUrl" style="width:30%">
      <div v-show="!spec_id&&!imgLoadingState"  @click="handleImgError" style="width:27%;height: 60%;background-color: #F5F6FA;display: flex;flex-direction: column;align-items: center;justify-content: center;cursor: pointer">
        <img style="width: 50px" src="../assets/make/public/icon_refresh.png">
        <div style="width: 60%;font-size: 12px;color: rgba(53,49,92,0.4);text-align: center;">
          照片加载失败，点我重新制作
        </div>
      </div>

      <div v-show="spec_id" :style="{width:box_photo_width_per,height:box_photo_height_per}" class="box-photo">
        <div style="width: 100%;height: 5%;display: flex;justify-content: center;align-items: center">{{currentPxSize[0]}}px</div>
        <div style="width: 7.9%;height: 84.2%;display: flex;justify-content: center;align-items: center">
          <div style="transform: rotate(-90deg)">{{currentMmSize[1]}}mm</div>
        </div>
        <img v-show="imgLoadingState" @load="imgSuccessListen" @error="imgErrorListen" :style="{backgroundImage:bgColor.colorValue}" class="photo" :src="photoUrl">
        <div v-show="!imgLoadingState" @click="handleImgError" class="photo" style="background-color: #F5F6FA;display: flex;flex-direction: column;align-items: center;justify-content: center;cursor: pointer">
          <img style="width: 50px" src="../assets/make/public/icon_refresh.png">
          <div style="width: 60%;font-size: 12px;color: rgba(53,49,92,0.4);text-align: center;">
            照片加载失败，点我重新制作
          </div>
        </div>
        <div style="width: 7.9%;height: 84.2%;display: flex;justify-content: center;align-items: center">
          <div style="transform: rotate(-90deg)">{{currentPxSize[1]}}px</div>
        </div>

        <div style="width: 100%;height: 5%;display: flex;justify-content: center;align-items: center">{{currentMmSize[0]}}mm</div>
      </div>
    </div>
    <div class="btn-container">
      <div @click="goMake" style="background-color: white;color:#4B00A4;border: 1px solid #4B00A4" class="btn">
        <img style="width: 16px;margin-right: 10px" src="../assets/make/preview/upload-btn-icon.png"/>重新上传
      </div>
      <div @click="goSave" style="background-color: #4B00A4;color:white;" class="btn">
        <img style="width: 16px;margin-right: 10px" src="../assets/make/preview/download-btn-icon.png"/>下载保存
      </div>
    </div>
    <RightDialog :noMake="false" @setBgColor="setBgColor" @handleMake="makePhoto" :backgroundColor="this.$store.state.sizeInfo.background_color"></RightDialog>
    <PhotoMakeFooter></PhotoMakeFooter>
    <OrderConfirmDialog @goPay="goPay" @close="closeOrderConfirm" :show="orderConfirmDialogShow" :backgroundColor="this.$store.state.sizeInfo.background_color"></OrderConfirmDialog>
    <PayDialog @close="closePayDialog" :payInfo="payInfo" :show="payDialogShow"></PayDialog>
  </div>
</template>

<script>
    // import api from "../makeOnlineApi/api";
    import PhotoMakeHeader from "../components/PhotoMakeHeader";
    import PhotoMakeFooter from "../components/PhotoMakeFooter";
    import SearchInput from "../components/SearchInput";
    import RightDialog from '../components/RightDialog'
    import OwnMarquee from "../components/Marquee";
    import OrderConfirmDialog from "../components/OrderConfirmDialog";
    import PayDialog from "../components/PayDialog";
    import api from "../makeOnlineApi/api";
    import utils from "../makeOnlineApi/utils";

    export default {
        name: "Preview",
        components:{OwnMarquee, PhotoMakeHeader,PhotoMakeFooter,SearchInput,RightDialog,OrderConfirmDialog,PayDialog},
        created() {
            console.log(this.$store.state.clothesId!=='-1',this.$store.state.clothesId)
            this.spec_id=this.$store.state.sizeInfo.spec_id
            this.photoUrl=this.$store.state.currentPhoto[this.$store.state.currentPhoto.length-1].image_url

            this.marqueeTxt = this.$store.state.sizeInfo&&this.$store.state.sizeInfo.spec_name?
                this.$store.state.sizeInfo.spec_name:'未选择'

            this.setBgColor(this.$store.state.bgNameSelected)
        },
        mounted() {
            this.boxWidth=document.getElementById('box').offsetWidth
            this.boxHeight=document.getElementById('box').offsetHeight
            this.$store.state.sizeInfo.spec_id&&this.photoSizeUtils()



        },
        data(){
            return{
                imgLoadingState:true,
                inputShow:false,
                photoUrl:'',
                isChooseSize:'', // 是否已选择规格制作
                marqueeTxt:'',
                spec_id: null,
                currentPxSize:[],
                currentMmSize:[],
                box_photo_width_per:'',
                box_photo_height_per:'',
                boxWidth:null,
                boxHeight:null,
                bgColor:{},
                orderConfirmDialogShow:false,
                payDialogShow:false,
                payInfo:{},
            }
        },
        computed: {
            sizeInfo() {
                return this.$store.state.sizeInfo;
            },
            currentPhoto(){
                return this.$store.state.currentPhoto;
            }
        },
        watch:{
            sizeInfo:function(newProps){

                this.spec_id=newProps.spec_id

                this.marqueeTxt = newProps&&newProps.spec_name?newProps.spec_name:'未选择执行哈谢谢'
                this.photoSizeUtils()
            },
            currentPhoto:function(newProps){
                console.log('换新照片',newProps)

                this.photoUrl=newProps[newProps.length-1].image_url
            },
            "$store.state.bgNameSelected":function (newProps) {
                console.log('设置背景色')
                this.setBgColor(newProps)
            }
        },

        methods:{
            imgSuccessListen(){
                this.imgLoadingState=true
            },
            imgErrorListen(){
              this.imgLoadingState=false
            },
            handleImgError(){
                this.makePhoto({})
            },

            inputFocus(){
                this.inputShow=true
            },

            // 处理图片宽高
            photoSizeUtils(){
                let sizeInfo = this.$store.state.sizeInfo

                if (sizeInfo.spec_id===-4) {
                    this.currentPxSize= [Number(sizeInfo.custom_size[0]),Number(sizeInfo.custom_size[1])]
                    this.currentMmSize=[((Number(sizeInfo.custom_size[0])/Number(sizeInfo.dpi))*25.4).toFixed(0),((Number(sizeInfo.custom_size[1])/Number(sizeInfo.dpi))*25.4).toFixed(0)]
                }else{
                    this.currentPxSize=[Number(sizeInfo.px_size.split(' ')[0]),Number(sizeInfo.px_size.split(' ')[2])]
                    this.currentMmSize=[Number(sizeInfo.mm_size.split(' ')[0]),Number(sizeInfo.mm_size.split(' ')[2])]
                }
                console.log('当前图片尺寸',this.currentPxSize)
                let ratio = this.currentPxSize[0]/this.currentPxSize[1]
                // box-photo 最大高 74.5%；最小高 57.3% 最大宽42.5%；最小宽32.1%

                // 图片根据当前screen缩小
                let box_photo_width=window.screen.width/1920*this.currentPxSize[0]/0.842
                let box_photo_height=window.screen.width/1920*this.currentPxSize[1]/0.842

                let boxWidth = this.boxWidth
                let boxHeight = this.boxHeight
                console.log('box_photo_width',box_photo_width,boxWidth)
                console.log('box_photo_height',box_photo_height,boxHeight)
                let box_photo_width_per=box_photo_width/boxWidth
                let box_photo_height_per=box_photo_height/boxHeight
                console.log('box_photo_height_per',box_photo_height_per)
                if (box_photo_height_per>0.745){
                    box_photo_height_per=0.745 // 当长度到规定的最大时 规定相应长为最大值 来缩小图片
                    box_photo_width=boxHeight*0.745*ratio
                    box_photo_width_per=box_photo_width/boxWidth
                }else if (box_photo_height_per<0.573){
                    box_photo_width_per=0.24  // 当长度到规定的最小时 规定相应宽为最大 放大图片
                    box_photo_height=boxWidth*0.24/ratio
                    box_photo_height_per=box_photo_height/boxHeight
                    if (box_photo_height_per>0.745){
                        box_photo_height_per=0.745
                        box_photo_width=boxHeight*0.745*ratio
                        box_photo_width_per=box_photo_width/boxWidth
                    }
                }else{
                     // 当长度到规定的区间时 规定相应长为当前值
                    box_photo_width=boxHeight*box_photo_height_per*ratio
                    box_photo_width_per=box_photo_width/boxWidth
                }
                this.box_photo_width_per=`${box_photo_width_per*100}%`
                this.box_photo_height_per=`${box_photo_height_per*100}%`




            },

            closeSearchDialog(){
                this.inputShow=false
            },

            setBgColor(name){

                const colorList = this.$store.state.sizeInfo.spec_id===-4?
                    utils.colorToLinearGradient(this.$store.state.sizeInfo.background_color) :
                    this.$store.state.sizeInfo.background_color
                this.bgColor = colorList&&colorList.filter((item)=>{
                    return name===item.name
                })[0]||{}
                this.$store.dispatch('updateBgSelected',name)
                console.log(this.bgColor)


            },

            goPay(params){
                this.closeOrderConfirm(false) //关闭对话框
                console.log('订单信息',params)
                this.payInfo=params
                this.payDialogShow=true
            },

            makePhoto(params){
                const loading = this.$loading({
                    lock: true,
                    text: '制作中',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                const sizeInfo=params&&params.sizeInfo?params.sizeInfo:this.$store.state.sizeInfo
                const fair_level=this.$store.state.fairLevel
                const clothesId=this.$store.state.clothesId

                let option={
                    spec_id:sizeInfo.spec_id,
                    key:this.$store.state.originKey,
                    fair_level:params.fair_level||fair_level,
                    list_clothes_id:params&&params.clothesId?['-1',params.clothesId]:['-1',clothesId],
                    need_resize:true,
                    custom_params:sizeInfo.spec_id===-4?sizeInfo:{},
                }
                api.getCertificatePhotoTaskId(option).then((res)=>{
                    let taskId=res.data.task_id
                    let getPhotoByTaskId=(taskId)=>{
                        api.getPhotoByTaskId(taskId).then(res=>{
                            console.log('结果',res.data.result)
                            this.$store.dispatch('updateCurrentPhoto',res.data.result)
                            if (params.sizeInfo){
                                this.$store.dispatch('updateSizeInfo',params.sizeInfo)
                                //当规格制作时默认设置背景色为颜色列表的第一个
                                this.setBgColor(params.sizeInfo.spec_id===-4?params.sizeInfo.background_color[0].color_name:params.sizeInfo.background_color[0].name)
                            }

                            params.clothesId&&this.$store.dispatch('updateClothesId',params.clothesId)
                            params.fair_level&&this.$store.dispatch('updateFairLevel',params.fair_level)
                            loading.close()
                        }).catch(error=>{
                            if (error.code!==482){
                                //
                                loading.close()

                            }else {
                                setTimeout(()=>{
                                    getPhotoByTaskId(taskId)
                                },500)

                            }
                        })
                    }
                    getPhotoByTaskId(taskId)
                }).catch(()=>{
                    loading.close()
                })
            },

            // 关闭确认订单对话框
            closeOrderConfirm(flag){
                this.orderConfirmDialogShow=flag
            },

            // 关闭支付对话框
            closePayDialog(flag){
                this.payDialogShow=flag
                this.$router.push({
                    path: '/order',
                })
            },

            goSave(){
                if (this.$store.state.sizeInfo.spec_id){
                    this.orderConfirmDialogShow=true
                }else {
                    this.$message.error({
                        message:'还未选择规格，请选择规格制作后保存'
                    })
                }

            },
            goMake(){
                this.$router.push({
                    path:'/uploadPhoto'
                })
            },
        },
    }
</script>

<style scoped>
  .page{
    background-color: #FAFAFA;
    height: 100%;
  }
  #box{
    width: 60%;
    height: 58%;
    /*background-color: #d9d9d9*/
    margin:0 0 1% 16%;
    background-image: url("../assets/make/public/makeBg.png");
    background-size: 100% 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  .box-marquee{
    width: 150px;height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #35315c;
    border-radius: 13px;
    opacity: 0.8;
  }
  .box-photo{
    background-image: url("../assets/make/preview/photo-border.png");
    background-size: 100% 100%;

    display: flex;
    flex-wrap: wrap;
    align-content: space-between;
    font-size: 12px;

  }
  .photo{
    width:84.2%;height: 84.2%
  }
  .btn-container{
    width: 60%;
    display: flex;
    justify-content: center;
    margin:3% 0 30px 16%;
  }
  .btn{
    width: 160px;height: 40px;
    border-radius: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    cursor: pointer;
    font-size: 14px;
    margin: 0 10px;
  }
  .search-contain{
    width: 60%;
    height: 40px;
    display: flex;
    margin:1% 0 1% 16%;
  }
  .search-input{
    width: 90%;
    height: 40px;

    outline:none;
    color: #35315c;
    border: 1px solid #FF7BAC;
    border-top-left-radius: 4px;
    border-bottom-left-radius: 4px;
    background-image: url(../assets/make/preview/search-icon.png);/*设置小图标*/

    background-size: 20px 20px;/*小图标的大小*/

    background-position: 2% 45%;/*小图标在input的位置*/

    background-repeat: no-repeat;/*背景小图标不重复*/

    padding: 0 4% 0 40px;/*设置input内边距*/
  }
  .search-btn{
    background-color: #FF7BAC;
    width: 10%;
    height: 42px;
    color: #FFFFFF;
    font-size: 18px;
    text-align: center;
    line-height: 42px;
    cursor: pointer;
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
  }


</style>
